import { Grid } from '@mui/material';
import React from 'react';
import Screen from '../../components/fragments/Screen';
import { familyActions } from '../../store/local/contents';
import CardHome from '../../components/legacy/CardHome';

export default function MyFamilyScreen() {
    return (
        <Screen title={'My Family'}>
            <Grid sx={{ mt: 0.5 }} container spacing={1}>
                {familyActions.map(({ icon, name, link, full, desc }) => {
                    return (
                        <CardHome
                            key={`${name}`}
                            icon={icon}
                            title={name}
                            link={link}
                            full={full}
                            desc={desc}
                        />
                    );
                })}
            </Grid>
        </Screen>
    );
}
